import { Box, Typography } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import { FileCopyIcon } from "src/Pages/components/Icons/Icons";
import { TitleWithValueCore } from "src/Pages/components/TitleWithValueCore/TitleWithValueCore";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { handleFormatDateIfIsNull } from "src/shared/Utils/handleFormatDateIfIsNull";

export const CardDadosPlano = () => {
  const { dataGetByIdContrato } = useContextContrato();

  if (!handleFormatDateIfIsNull) return null;

  return (
    <CardCore sxStyle={{ margin: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <FileCopyIcon sx={{ mr: 1 }} color="success" />

        <Typography sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
          Plano
        </Typography>
      </Box>
      <Box
        sx={{
          flexWrap: "wrap",
          display: "flex",
          "& > *": { margin: "12px 24px 12px 0" },
        }}
      >
        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Operadora"
          value={dataGetByIdContrato?.operator.name}
        />
        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Modalidade"
          value={dataGetByIdContrato?.modality.name}
        />

        {dataGetByIdContrato?.administrator?.name && (
          <TitleWithValueCore
            sxStyleTitle={{ fontWeight: "500" }}
            title="Administradora"
            value={dataGetByIdContrato?.administrator.name}
          />
        )}

        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          sxStyleValue={{ color: (theme) => theme.custom.color.money }}
          title="Mensalidade"
          value={FormatMoney(dataGetByIdContrato?.monthlyPayment)}
        />

        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Vidas"
          value={`${dataGetByIdContrato?.lives}`}
        />

        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Data de vencimento 1ªparc. *"
          value={FormatDateBR(
            handleFormatDateIfIsNull(
              dataGetByIdContrato?.firstInstallmentDueDate
            )
          )}
        />
        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Data de assinatura"
          value={FormatDateBR(
            handleFormatDateIfIsNull(dataGetByIdContrato?.subscriptionDate)
          )}
        />
        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Data de emissão"
          value={FormatDateBR(
            handleFormatDateIfIsNull(dataGetByIdContrato?.issuanceDate)
          )}
        />
        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Data de vigência"
          value={FormatDateBR(
            handleFormatDateIfIsNull(dataGetByIdContrato?.startDate)
          )}
        />
        <TitleWithValueCore
          sxStyleTitle={{ fontWeight: "500" }}
          title="Data de vencimento proposta"
          value={FormatDateBR(
            handleFormatDateIfIsNull(dataGetByIdContrato?.expirationDate)
          )}
        />
      </Box>
    </CardCore>
  );
};
